import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from './LandingPage/LandingPage';
import ProductPage from './ProductPage/ProductPage';
import ProductIntelligencePage from './ProductPage/ProductIntelligencePage';
import AboutUs from './AboutUs/AboutUs';
import UseCase from './UseCasePage/UseCases';
import PricingPage from './Pricing/PricingPage';
import ContactPage from './Contact Page/Contact';
import TermsOfService from './Legal/TermsOfService';
import PrivacyPolicy from './Legal/PrivacyPolicy';
import ScrollToTop from './ScrollToTop';
import { SignInModalProvider } from './shared/SignInModalContext';

export default function RouteComponent() {
  return (
  <><div>
      <Router>
        <SignInModalProvider>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/ProductInsurance" element={<ProductPage />} />
            <Route path="/Product" element={<Navigate to="/ProductInsurance" replace />} />
            <Route path="/ProductIntelligence" element={<ProductIntelligencePage />} />
            <Route path="/AboutUs" element={<AboutUs />} />
            <Route path="/Solutions" element={<UseCase />} />
            <Route path="/UseCases" element={<Navigate to="/Solutions" replace />} />
            <Route path="/Pricing" element={<PricingPage />} />
            <Route path="/Contact" element={<ContactPage />} />
            <Route path="/TermsOfService" element={<TermsOfService />} />
            <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
          </Routes>
        </SignInModalProvider>
      </Router>
    </div></>
  );
}
